import {useEffect} from "react";
import Home from "./components/Home";
import Login from "./components/Login/Login";
import {getNotificationProvider, isDevelopmentMode} from "./service/utils";
import {
  initializeFCM,
  onMessageListener,
} from "./service/firebase/FirebaseService";

function App() {
  const notificationProvider = getNotificationProvider();
  const location = window.location.hostname;
  const isEmulatorMode = location === "localhost" || location === "127.0.0.1";
  console.debug("isEmulatorMode: ", isEmulatorMode);
  let showLogin = false;
  if (isEmulatorMode || isDevelopmentMode()) {
    const urlParams = new URLSearchParams(window.location.search);
    console.debug("urlParams: ", urlParams);
    showLogin = urlParams.get("login") === "true";
    console.debug("showLogin: ", showLogin);
  }

  useEffect(() => {
    if (notificationProvider === "firestore") {
      initializeFCM();
      const messageListener = onMessageListener();
      if (messageListener && messageListener.then) {
        messageListener.then((payload: any) => {
          console.log("Received foreground message:", payload);
        });
      }
    }
  }, [notificationProvider]);

  return <div className="App">{showLogin ? <Login /> : <Home />}</div>;
}

export default App;
